import { LoadingScreen } from '@/components/loading/LoadingScreen';

export function LoadingPage() {
  return <LoadingScreen />;
}
